<template>
  <div>
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('meta.orders'), name: 'orders' }, { text: $t('newOrder.title') }]" />
      </template>
    </SectionHeader>

    <Form @submit="createOrder">
      <div class="content-body">
        <transition name="slide-fade">
          <div>
            <OrderTypeSelect v-model="order.type" :company="order.company" :disabled="order.status !== 'open'" />
            <p>{{ $t('newOrder.noCompanySelected') }}</p>
          </div>
        </transition>

        <transition name="slide-fade">
          <div v-if="order.type">
            <EmptyingForm v-if="order.type == 'EmptyingOrder'" v-model="order" />
            <GatheringForm v-if="order.type == 'GatheringOrder'" v-model="order" />
            <GatheringPickupForm v-if="order.type == 'GatheringPickupOrder'" v-model="order" />
            <FreeSwitchingForm v-if="order.type == 'FreeSwitchingOrder'" v-model="order" />
            <OverheadLoadingForm v-if="order.type == 'OverheadLoadingOrder'" v-model="order" />
            <PickupForm v-if="order.type == 'PickupOrder'" v-model="order" />
            <PickupAndWeighForm v-if="order.type == 'PickupAndWeighOrder'" v-model="order" />
            <PositioningForm v-if="order.type == 'PositioningOrder'" v-model="order" />
            <SwitchingForm v-if="order.type == 'SwitchingOrder'" v-model="order" />

            <FollowUpOrderTypeForm v-model="order.follow_up_order_type" :order="order" />

            <Button type="submit">Submit</Button>
          </div>
        </transition>
      </div>
    </Form>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs'
import Button from '@/components/Button/index.vue'
import Form from '@/components/Form/index.vue'
import EmptyingForm from '@/components/Orders/forms/EmptyingForm.vue'
import FreeSwitchingForm from '@/components/Orders/forms/FreeSwitchingForm.vue'
import GatheringForm from '@/components/Orders/forms/GatheringForm.vue'
import GatheringPickupForm from '@/components/Orders/forms/GatheringPickupForm.vue'
import OverheadLoadingForm from '@/components/Orders/forms/OverheadLoadingForm.vue'
import PickupAndWeighForm from '@/components/Orders/forms/PickupAndWeighForm.vue'
import PickupForm from '@/components/Orders/forms/PickupForm.vue'
import PositioningForm from '@/components/Orders/forms/PositioningForm.vue'
import SwitchingForm from '@/components/Orders/forms/SwitchingForm.vue'
import FollowUpOrderTypeForm from '@/components/Orders/forms/sections/elements/FollowUpOrderTypeForm.vue'
import OrderTypeSelect from '@/components/Orders/forms/sections/elements/OrderTypeSelect.vue'
import SectionHeader from '@/components/SectionHeader'

import ordersApi from '@/api/orders'

export default {
  name: 'NewOrderView',
  components: {
    BreadCrumbs,
    Button,
    EmptyingForm,
    FollowUpOrderTypeForm,
    FreeSwitchingForm,
    Form,
    GatheringForm,
    GatheringPickupForm,
    OrderTypeSelect,
    OverheadLoadingForm,
    PickupForm,
    PickupAndWeighForm,
    PositioningForm,
    SectionHeader,
    SwitchingForm,
  },
  inject: ['companyUser'],
  data() {
    return {
      invalid: false,
      order: {
        status: 'open',
        type: null,
        company_uuid: this.companyUser.company_uuid,
        company: this.companyUser.company,
      },
    }
  },
  methods: {
    async createOrder() {
      const { success, data } = await ordersApi.create(this.order)

      if (success) this.$router.push(`/orders/${data.order.uuid}`)
    },
  },
}
</script>
